import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getPdfPageCount } from "../../utils/utils";

const FilesUploadBox = ({ loading, selectedShop, files, setFiles, onBack, onContinue }) => {
    const inputRef = useRef(null);

    const handleFiles = async (e) => {
        const selected = Array.from(e.target.files || []);

        const formattedFiles = await Promise.all(selected.map(async (file) => ({
            id: crypto.randomUUID(),
            file,
            pageCount: file.type === "application/pdf" ? await getPdfPageCount(file) : 1,
            printOptions: {
                printType: "",
                paperSize: "",
                quality: "",
                quantity: "",
                paperThickness: "",
                orientation: "",
                color: "B/W",
                binding: "No",
                doubleSided: "No",
                printNeedBy: "",
                additionalNotes: ""
            }
        })));

        setFiles((prev) => [...prev, ...formattedFiles]);
    };


    const removeFile = (index) => {
        setFiles((prev) => prev.filter((_, i) => i !== index));
    };


    useEffect(() => {
        console.log('Files', files);
    }, [files]);

    return (
        <div className="w-full max-w-[720px] bg-white rounded-[16px] shadow-[0px_2px_28px_0px_rgba(0,0,0,0.07)] p-[24px] md:p-[40px] flex flex-col gap-[28px]">

            {/* HEADER */}
            <div>
                {/* ERROR */}
                {
                    !loading && !selectedShop?.uid && (
                        <div className="bg-[#fff0f0] border border-[#ffcdd2] rounded-[10px] px-[16px] py-[12px] mb-[16px]">
                            <p className="font-medium text-[13px] text-[#d32f2f]">
                                No Shop Selected or Found. Please go back and select a shop before uploading your files.
                            </p>
                        </div>
                    )
                }
                <h1 className="font-semibold text-[24px] text-[#212326] mb-[6px]">
                    Upload your files
                </h1>
                <p className="font-medium text-[14px] text-[#717182] flex items-center">
                    Add the documents you'd like printed at{" "}
                    <span className="font-semibold text-[#212326] flex items-center ml-[3px]">
                        {loading ? (
                            <span className="flex items-end gap-[2px]">
                                <span className="w-[4px] h-[4px] bg-[#9298a0] rounded-full animate-bounce"></span>
                                <span
                                    className="w-[4px] h-[4px] bg-[#9298a0] rounded-full animate-bounce"
                                    style={{ animationDelay: "0.15s" }}
                                ></span>
                                <span
                                    className="w-[4px] h-[4px] bg-[#9298a0] rounded-full animate-bounce"
                                    style={{ animationDelay: "0.3s" }}
                                ></span>
                            </span>
                        ) : selectedShop?.shopName ? (
                            selectedShop.shopName
                        ) : (
                            ""
                        )}
                    </span>
                </p>
            </div>

            {/* DROPZONE */}
            <div
                onClick={() => inputRef.current.click()}
                className="relative border-2 border-dashed rounded-[12px] p-[32px] flex flex-col items-center gap-[12px] cursor-pointer border-[#e4e5e7] hover:border-[#c0c2c6] bg-[#fafafa]"
            >
                <input
                    ref={inputRef}
                    type="file"
                    multiple
                    className="hidden"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.psd,.ai,.eps,.svg,.tiff"
                    onChange={handleFiles}
                />

                <div className="w-[48px] h-[48px] rounded-full bg-[#fff0ec] flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                        className="w-[22px] h-[22px] text-[#ff5323]">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                        <polyline points="17 8 12 3 7 8"></polyline>
                        <line x1="12" x2="12" y1="3" y2="15"></line>
                    </svg>
                </div>

                <p className="font-['Plus_Jakarta_Sans',sans-serif] font-semibold text-[16px] text-[#212326]">
                    Drag & drop files here
                </p>

                <p className="font-['Plus_Jakarta_Sans',sans-serif] font-medium text-[13px] text-[#9298a0]">
                    or click to browse - PDF, DOC, JPG, PNG, PSD, AI, EPS
                </p>
            </div>

            {/* FILE LIST */}
            {files.length > 0 && (
                <div className="flex flex-col gap-[8px]">
                    {files.map((file, index) => (
                        <div
                            key={index}
                            className="flex items-center gap-[12px] px-[16px] py-[12px] bg-[#fafafa] rounded-[10px] border border-[#e4e5e7]"
                        >
                            {file.file.type.startsWith("image/") ?
                                (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"

                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-image w-[18px] h-[18px] text-[#ff5323]">
                                        <rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect>
                                        <circle cx="9" cy="9" r="2"></circle>
                                        <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"></path>
                                    </svg>
                                ) : (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-text w-[18px] h-[18px] text-[#ff5323]"
                                    ><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                                        <path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path>
                                        <path d="M16 13H8"></path><path d="M16 17H8"></path>
                                    </svg>
                                )
                            }


                            <div className="flex-1 min-w-0">
                                <p className="font-medium text-[14px] text-[#212326] truncate">
                                    {file.file.name}
                                </p>
                                <p className="font-medium text-[12px] text-[#9298a0]">
                                    {(file.file.size / 1024).toFixed(1)} KB
                                </p>
                            </div>

                            <button
                                onClick={() => removeFile(index)}
                                className="p-[4px] hover:bg-[#e4e5e7] rounded-[6px]"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                                    className="w-[16px] h-[16px] text-[#9298a0]">
                                    <path d="M18 6 6 18"></path>
                                    <path d="m6 6 12 12"></path>
                                </svg>
                            </button>
                        </div>
                    ))}
                </div>
            )}

            {/* ACTIONS */}
            <div className="flex flex-col-reverse md:flex-row md:justify-between gap-[10px]">
                <button
                    className="flex items-center justify-center gap-[8px] w-full md:w-auto px-[20px] py-[12px] rounded-[10px] border border-[#e4e5e7] font-semibold text-[15px] text-[#212326] hover:bg-[#f4f5f6] transition-colors"
                    onClick={onBack}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-left w-[16px] h-[16px]">
                        <path d="m15 18-6-6 6-6"></path>
                    </svg>
                    Back
                </button>

                <button
                    disabled={files.length === 0}
                    onClick={onContinue}
                    className={`flex items-center justify-center gap-[8px] w-full md:w-auto px-[20px] md:px-[28px] py-[12px] rounded-[10px] font-semibold text-[15px] transition-all
                        ${files.length === 0
                            ? "bg-[#e4e5e7] text-[#9298a0] cursor-not-allowed"
                            : "bg-[#ff5323] text-white hover:bg-[#e64a1f]"
                        }`}
                >
                    Continue
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-right w-[16px] h-[16px]">
                        <path d="M5 12h14"></path>
                        <path d="m12 5 7 7-7 7"></path>
                    </svg>
                </button>
            </div>

        </div>
    );
};

export default FilesUploadBox;